<template>
  <div class="upload-container">
    <Upload
      class="upload-style"
      :action="uploadUrl"
      :on-success="handleSuccess"
      :on-error="handleError"
      :headers="headers"
      :format="['wav']"
      :show-upload-list="false"
      accept="wav"
      :disabled="disabled"
    >
      {{ disabled ? '-' : '上传录音' }}
    </Upload>
    <audio-play :filepath="filepath">
      <Icon
        color="#ed4014"
        style="vertical-align: super; padding-right: 10px"
        type="ios-trash-outline"
        @click="$emit('delect')"
      />
    </audio-play>
  </div>
</template>
<script>
import { uploadA } from "@/server/api";
import { getToken } from '@/utils/auth'
import audioPlay from './AudioPlay.vue';

export default {
  components: { audioPlay },
  props: {
    filepath: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      uploadUrl: uploadA,
      headers: { Authorization: getToken() },
    };
  },
  methods: {
    // 语音上传成功
    handleSuccess(res) {
      this.$emit("uploadSuccess", res.data.filepath);
    },
    // 上传失败
    handleError() {
      this.$Message.error("网络错误请稍后再试");
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-container {
  display: flex;
  align-items: center;
}
.upload-style {
  vertical-align: super;
  padding-right: 10px;
  color: #457ed1;
  cursor: pointer;
}
</style>